<template>
  <div class="cp-section">
    <div v-if="!processing && !isCPLoading" class="cp-section__list">
      <div class="cp-subheading mt-0 d-none d-md-flex justify-content-between">
        <div v-if="input">{{input.formatted_label | stripHTML}}</div>
        <b-button @click="toggleSidebar()" class="no-outline-btn cp-section__btn new__btn d-none d-lg-flex" v-if="paymentSources.length">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 4.875V16.125M15.625 10.5H4.375" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Add New Payment Method</span>
        </b-button>
      </div>
      <div class="cp-section__container " v-if="paymentSources.length">
        <div class="accordion" role="tablist">
          <PaymentInfoTile v-bind:key="paymentSource.id" v-for="paymentSource in paymentSources" @update="updatePaymentSource" :payment-source="paymentSource" />
        </div>
        <b-button @click="toggleSidebar()" class="cp-section__btn new__btn no-outline-btn d-flex d-lg-none">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M10 4.875V16.125M15.625 10.5H4.375" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Add New Payment Method</span>
        </b-button>
      </div>
      <div class="cp-section__container" v-else>
        <b-card class="cp__card empty">
          <p class="cp__card__empty__text text-center">
            There are no payment methods associated with your account.
            Click "Add payment method" to get started.
          </p>
          <b-button class="cp-section__btn no-outline-btn new__btn" @click="toggleSidebar()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none">
              <path d="M10 4.875V16.125M15.625 10.5H4.375" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Add New Payment Method</span>
          </b-button>
        </b-card>
      </div>
    </div>
    <ProcessingLoader v-else />
    <PaymentSidebar v-if="selectedPaymentSource"
                    :payment-source="selectedPaymentSource"
                    @clear="updatePaymentSource(null)"
                    @success="updateSelected"
    />
  </div>
</template>

<script>

import {mapState} from 'vuex'
import {PaymentSource, PaymentSourceStrings} from '@/constants'
import {getExpDate} from '@/utils'
import PaymentInfoTile from '@/components/PaymentInfo/PaymentInfoTile'
import PaymentSidebar from '@/components/PaymentInfo/PaymentSidebar'
import ProcessingLoader from '@/components/ProcessingLoader'

export default {
  name: 'CustomerPortalPaymentInfo',
  components: {ProcessingLoader, PaymentSidebar, PaymentInfoTile},
  props: {
    input: Object
  },
  data: function() {
    return {
      processing: true,
      paymentSources: [],
      selectedPaymentSource: null
    }
  },
  computed: {
    ...mapState(['session', 'isCPLoading'])
  },
  methods: {
    getPaymentSource: function(source) {
      return {
        id: source.id,
        isDefault: source.is_default,
        canUpdate: source.can_update,
        isCard: source.payment_source === PaymentSource.CreditCard,
        sourceType: source.payment_source,
        source: PaymentSourceStrings[source.payment_source],
        type: source.cc_type,
        last4: source.cc_last4,
        expDate: getExpDate(source.cc_exp_date, true),
        status: source.latest_status
      }
    },
    toggleSidebar: function() {
      this.selectedPaymentSource = {
        id: null,
        isDefault: false,
        type: null,
        last4: null,
        expDate: null,
        isActive: true
      }
    },
    fetchPaymentSources: function() {
      this.processing = true
      this.$store.dispatch('get_payment_sources')
        .then(paymentSources => {
          this.paymentSources = []
          for (let source of paymentSources) {
            const paymentSource = this.getPaymentSource(source)
            if (paymentSource.isDefault) {
              this.paymentSources.unshift(paymentSource)
            } else {
              this.paymentSources.push(paymentSource)
            }
          }

          this.processing = false
        })
        .catch(err => {
          this.$store.commit('critical_error', err)
          this.processing = false
        })
    },
    updatePaymentSource: function(paymentSource) {
      this.selectedPaymentSource = paymentSource
    },
    updateSelected: function() {
      this.fetchPaymentSources()
      this.updatePaymentSource(null)
    }
  },
  created() {
    this.fetchPaymentSources()
  }
}
</script>

<style scoped>

</style>
